<template>
  <div class="form-group">
    <label class="form-label">Событие*</label>
    <div class="checkbox-group">
      <div class="label-checkbox-pair">
        <input id="interior-decoration-and-equipment" type="checkbox" v-model="interiorDecorationAndEquipment">
        <label for="interior-decoration-and-equipment">Внутренняя отделка и инженерное оборудование</label>
        <input type="hidden" name="weatherInTheHouseEvents[interiorDecorationAndEquipment]" :value="interiorDecorationAndEquipment">
      </div>

      <div class="label-checkbox-pair">
        <input id="home-movable-property" type="checkbox" v-model="homeMovableProperty">
        <label for="home-movable-property">Домашнее движимое имущество</label>
        <input type="hidden" name="weatherInTheHouseEvents[homeMovableProperty]" :value="homeMovableProperty">
      </div>

      <div class="label-checkbox-pair">
        <input id="responsibility" type="checkbox" v-model="responsibility">
        <label for="responsibility">Ответственность перед третьими лицами</label>
        <input type="hidden" name="weatherInTheHouseEvents[responsibility]" :value="responsibility">
      </div>
    </div>
  </div>

  <div class="form-group">
    <label class="form-label">Причина события*</label>
    <CustomSelect name="cause" @initialize="onSelectInitialize" @itemSelected="onItemSelected">
      <option value="WaterDamage">Повреждение водой (залив)</option>
      <option value="Fire">Пожар</option>
      <option value="LightningStrike">Удар молнии</option>
      <option value="IllegalActions">Противоправные действия третьих лиц</option>
      <option value="Explosion">Взрыв</option>
      <option value="Disaster">Стихийное бедствие</option>
      <option value="Other">Другое</option>
    </CustomSelect>
  </div>

  <div class="form-group">
    <label class="form-label">В отношении кого наступило страховое событие</label>

    <div class="checkbox-group">
      <div class="label-checkbox-pair">
        <input id="insured-or-owner" type="checkbox" v-model="insuredOrOwner">
        <label for="insured-or-owner">Страхователь или собственник</label>
        <input type="hidden" name="eventAffected[insuredOrOwner]" :value="insuredOrOwner">
      </div>

      <div class="label-checkbox-pair">
        <input id="third-person" type="checkbox" v-model="thirdPerson">
        <label for="third-person">Третьи лица</label>
        <input type="hidden" name="eventAffected[thirdPerson]" :value="thirdPerson">
      </div>
    </div>
  </div>

  <InputWithLabel
      type="text"
      name="address"
      :errors="v$.address.$errors"
      v-model="address"
      @blur="v$.address.$touch"
      scroll-into-view-if-errors
  >
    Адрес застрахованного имущества*
  </InputWithLabel>

  <div class="form-group">
    <label class="form-label">Что именно произошло (дополнительные комментарии к событию)</label>
    <textarea name="comments" class="form-textarea" rows="6" v-model="comments"></textarea>
  </div>

  <ContractInfoApplicant/>
</template>

<script>
import ContractInfoApplicant from "@/components/insurances/shared/ContractInfoApplicant";
import * as mns from '@/store/mutation-types';
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import InputWithLabel from "@/components/utils/InputWithLabel";
import CustomSelect from "@/components/utils/CustomSelect";

export default {
  anotherNameLife: "WeatherInTheHouse",
  components: {InputWithLabel, ContractInfoApplicant, CustomSelect},
  data(){
    return{
      v$: useVuelidate(),
    };
  },
  validations(){
    return {
      address: {
        required: helpers.withMessage('Поле должно быть заполнено', required),
      },
    };
  },
  methods: {
    onSelectInitialize(event){
      this.$store.commit(mns.SET_EVENT, event.getValue().value);
    },
    onItemSelected(event){
      this.$store.commit(mns.SET_EVENT, event.detail.choice.value);
    },
  },
  computed: {
    interiorDecorationAndEquipment: {
      get(){
        return this.$store.getters.interiorDecorationAndEquipment;
      },
      set(value){
        this.$store.commit(mns.SET_INTERIOR_DECORATION_AND_EQUIPMENT, value);
      }
    },
    homeMovableProperty: {
      get(){
        return this.$store.getters.homeMovableProperty;
      },
      set(value){
        this.$store.commit(mns.SET_HOME_MOVABLE_PROPERTY, value);
      }
    },
    responsibility: {
      get(){
        return this.$store.getters.responsibility;
      },
      set(value){
        this.$store.commit(mns.SET_RESPONSIBILITY, value);
      }
    },
    insuredOrOwner: {
      get(){
        return this.$store.getters.insuredOrOwner;
      },
      set(value){
        this.$store.commit(mns.SET_INSURED_OR_OWNER, value);
      }
    },
    thirdPerson: {
      get(){
        return this.$store.getters.thirdPerson;
      },
      set(value){
        this.$store.commit(mns.SET_THIRD_PERSON, value);
      }
    },
    address: {
      get(){
        return this.$store.getters.address;
      },
      set(value){
        this.$store.commit(mns.SET_ADDRESS, value);
      }
    },
    comments: {
      get(){
        return this.$store.getters.comments;
      },
      set(value){
        this.$store.commit(mns.SET_COMMENTS, value);
      }
    }
  }
}
</script>

<style scoped>

</style>